export const CtxSegmentTypes = {
  ALL: {
    name: 'All',
    value: '',
  },
  Cohort: {
    name: 'Cohort 1.0',
    value: 0,
  },
  Query: {
    name: 'Query',
    value: 1,
  },
  Cohort2: {
    name: 'Cohort 2.0',
    value: 2,
  },
  Custom: {
    name: 'Custom',
    value: 3,
  },
  Adspresso: {
    name: 'Adspresso',
    value: 4,
  },
  ContentLibrary: {
    name: 'Content Library',
    value: 5,
  },
  Viral: {
    name: 'Viral Library',
    value: 7,
  },
  MindsetLibrary: {
    name: 'Mindset Library',
    value: 8,
  },
};
